// Gets country code from current URL path
export const getCountryFromUrl = () => {
    const pathName = window.location.pathname;
    const countryMatch = pathName.match(/\/([A-Z]{2})\//);
    return countryMatch ? countryMatch[1] : 'LK';
};

// Gets full country name from country code
export const getCountryNameFromCode = (countryCode) => {
    const countryMap = {
        'LK': 'Sri-Lanka',
    };

    return countryMap[countryCode] || countryCode;
};

// Checks if current page should hide the chatbot
export const shouldHideChatbot = () => {
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;

    // Check for space/bookings pages with eventTypeId parameter
    // This covers both /space/bookings and /Sri-Lanka/space/bookings patterns
    const isBookingPage = currentPath.includes('/space/bookings');
    const hasEventTypeId = currentSearch.includes('eventTypeId');

    // Debug logging (remove in production)
    // if (process.env.NODE_ENV === 'development') {
    //     console.log('Chatbot popup visibility check:', {
    //         currentPath,
    //         currentSearch,
    //         isBookingPage,
    //         hasEventTypeId,
    //         shouldHide: isBookingPage && hasEventTypeId
    //     });
    // }

    return isBookingPage && hasEventTypeId;
};

// Checks if workspace types are loaded from Redux state
export const areWorkspaceTypesLoaded = (spaceListingTypes, spaceActivities, searchResultTypes, homePageTypes) => {
    return spaceListingTypes?.length > 0 ||
        spaceActivities?.length > 0 ||
        searchResultTypes?.length > 0 ||
        homePageTypes?.length > 0;
};

// Constructs booking URL with parameters
export const constructBookingUrl = (params) => {
    const { country, eventTypeId, spaceId, unit = 'hour' } = params;

    // Convert country code to full name if needed
    const countryName = getCountryNameFromCode(country);

    return `/${countryName}/space/bookings?eventTypeId=${eventTypeId}&spaceId=${spaceId}&unit=${unit}`;
};

// Gets current page path and search parameters
export const getCurrentPageInfo = () => {
    return {
        pathname: window.location.pathname,
        search: window.location.search,
        href: window.location.href
    };
};

// Checks if current page matches a specific pattern
export const isCurrentPage = (pattern) => {
    const currentPath = window.location.pathname;

    if (typeof pattern === 'string') {
        return currentPath.includes(pattern);
    } else if (pattern instanceof RegExp) {
        return pattern.test(currentPath);
    }

    return false;
};

// Extracts query parameters from current URL
export const getQueryParams = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};

    for (const [key, value] of searchParams.entries()) {
        params[key] = value;
    }

    return params;
};

// Checks if a specific query parameter exists and has a value
export const hasQueryParam = (paramName) => {
    const params = getQueryParams();
    return params.hasOwnProperty(paramName) && params[paramName] !== '';
};

// Gets the value of a specific query parameter
export const getQueryParam = (paramName, defaultValue = '') => {
    const params = getQueryParams();
    return params[paramName] || defaultValue;
};
